module.exports = __webpack_public_path__ + "static/media/unfold_more-24px.119743f5.svg";